import { ROUTE_PROFILE_DESIGN_STUDIO } from '@/router'
import type { ResponseData } from '@/composables/app/useHandleFormSubmitResponse'
import { useHandleFormSubmitResponse } from '@/composables/app/useHandleFormSubmitResponse'
import type { CombinedError } from '@urql/vue'

type EnquiryResponseData = {
    data: ResponseData | undefined
    error: CombinedError | undefined
    redirect?: string | null
}

export function useHandleEnquiryResponse(): {
    handleEnquiryResponse: ({
        error,
        data,
        redirect,
    }: EnquiryResponseData) => void
} {
    const { handleFormSubmitResponse } = useHandleFormSubmitResponse(
        ROUTE_PROFILE_DESIGN_STUDIO
    )

    const handleEnquiryResponse = ({
        error,
        data,
        redirect,
    }: EnquiryResponseData) => {
        if (error || !data) {
            return
        }

        handleFormSubmitResponse(data, redirect)
    }

    return { handleEnquiryResponse }
}
